<script>import "@glidejs/glide/dist/css/glide.core.min.css";
import Glide, {
  Swipe,
  Breakpoints,
  Controls,
  Autoplay
} from "@glidejs/glide/dist/glide.modular.esm.js";
import DynamicComponent from "../../components/DynamicComponent.svelte";
import { attrValue } from "../../../utils/html";
var positionControlsEnmu = /* @__PURE__ */ ((positionControlsEnmu2) => {
  positionControlsEnmu2["TOP"] = "top";
  positionControlsEnmu2["BOTTOM"] = "bottom";
  return positionControlsEnmu2;
})(positionControlsEnmu || {});
export let sliderClassNames = null;
export let trackClassNames = null;
export let slidesClassNames = null;
export let slideClassNames = null;
export let config = {};
export let swipe = false;
export let breakpoints = false;
export let controls = false;
export let autoplay = false;
export let slider = null;
export let slides;
export let fade = false;
export let spin = false;
export let positionControls = "top";
if (spin)
  config = {
    startAt: 1,
    type: "carousel",
    gap: 0,
    perView: 3
  };
const init = (node) => {
  slider = new Glide(node, config);
  let modules = {};
  controls && (modules = { ...modules, Controls });
  swipe && (modules = { ...modules, Swipe });
  breakpoints && (modules = { ...modules, Breakpoints });
  autoplay && (modules = { ...modules, Autoplay });
  slider.mount(modules);
};
</script>

<div class={attrValue(['glide', sliderClassNames])} use:init class:fade class:spin>
	{#if positionControls === positionControlsEnmu.TOP}
		<slot name="controls" />
	{/if}
	<div class={attrValue(['glide__track', trackClassNames])} data-glide-el="track">
		<ul class={attrValue(['glide__slides', slidesClassNames])}>
			{#if slides}
				{#each slides as slide}
					<li class={attrValue(['glide__slide', slideClassNames])}>
						<DynamicComponent component={slide} />
					</li>
				{/each}
				<slot name="extra-slide" />
			{/if}
		</ul>
	</div>
	{#if positionControls === positionControlsEnmu.BOTTOM}
		<slot name="controls" />
	{/if}
</div>

<style>div :global(.glide__slide){height:auto!important}.fade :global(.glide__slides){display:block;height:100%!important;transform:none!important;width:auto!important}.fade :global(.glide__slide){height:100%!important;left:0;margin-left:0!important;margin-right:0!important;opacity:0;position:absolute;top:0;transition:opacity .3s;width:100%!important}.fade :global(.glide__slide--active){opacity:1!important;z-index:1}.spin :global(.glide__slides){display:grid;justify-content:center;transform:none!important;width:auto!important}.spin :global(.glide__slide){display:flex;grid-column-start:1;grid-row-start:1;height:100%}@media (min-width:1024px){.spin :global(.glide__slide){width:270px!important}}@media (min-width:1280px){.spin :global(.glide__slide){width:310px!important}}@media (min-width:1536px){.spin :global(.glide__slide){width:350px!important}}.spin :global(.glide__slide){flex-shrink:0;opacity:0;scale:.8;transition:scale .5s ease,opacity .3s ease,translate .7s ease .2s}@media (min-width:1024px){.spin :global(.glide__slide .card>a){height:100px!important}}@media (min-width:1280px){.spin :global(.glide__slide .card>a){height:200px!important}}@media (min-width:1536px){.spin :global(.glide__slide .card>a){height:238px!important}}.spin :global(.glide__slide--active){opacity:1;scale:1;z-index:2}.spin :global(.glide__slide--active+li){opacity:1;scale:.9;transition:opacity .5s ease .5s,scale .3s ease .5s,translate .7s ease 0s;translate:105%}.spin :global(:has(+.glide__slide--active)){opacity:1;scale:.9;transition:opacity .5s ease .2s,scale .3s ease,translate .7s ease 0s;translate:-105%}</style>
